export default "__VITE_ASSET__Dhr3fBxV__"